import React, { Component } from 'react';

class Apps extends Component {
  render() {

    if(this.props.data){
      var message = this.props.data.message;
      var apps = this.props.data.apps.map(function(app){
        return <a key={app.name} className="app-card" href={app.url} title={app.name}>
          <img className="app-icon" alt={app.name + ' icon'} src={'images/apps/' + app.icon} />
          <h3>{app.name}</h3>
          <p>{app.tagline}</p>
        </a>
      })
    }

    return (
      <section id="apps">

      <div className="row">

         <div className="twelve columns">

            <h1>My Apps</h1>
            <p className="apps-message">{message}</p>

            <div className="apps-grid">
                {apps}
            </div>
          </div>
      </div>
   </section>
    );
  }
}

export default Apps;
